export const LocationStateCodeAU = {
    NSW: 'NSW',
    VIC: 'VIC',
    QLD: 'QLD',
    WA: 'WA',
    SA: 'SA',
    TAS: 'TAS',
    ACT: 'ACT',
    NT: 'NT',
} as const;

export type LocationStateCodeAU =
    (typeof LocationStateCodeAU)[keyof typeof LocationStateCodeAU];

export const LocationStateNameAU = {
    [LocationStateCodeAU.NSW]: 'New South Wales',
    [LocationStateCodeAU.VIC]: 'Victoria',
    [LocationStateCodeAU.QLD]: 'Queensland',
    [LocationStateCodeAU.WA]: 'Western Australia',
    [LocationStateCodeAU.SA]: 'South Australia',
    [LocationStateCodeAU.TAS]: 'Tasmania',
    [LocationStateCodeAU.ACT]: 'Australian Capital Territory',
    [LocationStateCodeAU.NT]: 'Northern Territory',
} as const;

export type LocationStateNameAU =
    (typeof LocationStateNameAU)[LocationStateCodeAU];

export interface LocationStateAU {
    code: LocationStateCodeAU;
    name: string;
}

export const LOCATION_STATE_AU: readonly LocationStateAU[] = [
    {
        code: LocationStateCodeAU.NSW,
        name: LocationStateNameAU[LocationStateCodeAU.NSW],
    },
    {
        code: LocationStateCodeAU.VIC,
        name: LocationStateNameAU[LocationStateCodeAU.VIC],
    },
    {
        code: LocationStateCodeAU.QLD,
        name: LocationStateNameAU[LocationStateCodeAU.QLD],
    },
    {
        code: LocationStateCodeAU.WA,
        name: LocationStateNameAU[LocationStateCodeAU.WA],
    },
    {
        code: LocationStateCodeAU.SA,
        name: LocationStateNameAU[LocationStateCodeAU.SA],
    },
    {
        code: LocationStateCodeAU.TAS,
        name: LocationStateNameAU[LocationStateCodeAU.TAS],
    },
    {
        code: LocationStateCodeAU.ACT,
        name: LocationStateNameAU[LocationStateCodeAU.ACT],
    },
    {
        code: LocationStateCodeAU.NT,
        name: LocationStateNameAU[LocationStateCodeAU.NT],
    },
] as const;

export function getLocationStateNameAU(
    code: LocationStateCodeAU
): LocationStateNameAU {
    return LocationStateNameAU[code];
}
